import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useCurrentUser } from './current-user-hook'
import { AppStore } from '../store'
import { DataAccessState } from '../store/private-routes/types'
import { accessAllowedAction, accessDeniedAction, verifyingAccessAction } from '../store/private-routes/actions'

export const useVerifyingAccess = (): { gotToLogin: string; isVerifying: boolean; accessDenied: boolean } => {
  const { gotToLogin, isVerifying, accessDenied } = useSelector<AppStore, DataAccessState>(
    ({ privateRouteStore }) => privateRouteStore
  )

  const {
    isLogged,
    statusFetch: { error },
  } = useCurrentUser()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(verifyingAccessAction())
  }, [])

  useEffect(() => {
    if (error || accessDenied) {
      dispatch(accessDeniedAction())
    }

    if (isLogged !== null) {
      const success = isLogged
      if (!success) {
        dispatch(accessDeniedAction())
      } else {
        dispatch(accessAllowedAction())
      }
    }
  }, [error, isLogged])

  return {
    gotToLogin,
    isVerifying,
    accessDenied,
  }
}
